import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EmployeeFundingDetails } from '@flexyoo/employee/models';
import { FlexyooLocalizedNamePipe, FlexyooNumberPipe } from '@flexyoo/shared/pipes';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'flexyoo-employee-basket-fundings-list',
  templateUrl: './employee-basket-fundings-list.component.html',
  styleUrl: './employee-basket-fundings-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FlexyooNumberPipe, FlexyooLocalizedNamePipe],
})
export class EmployeeBasketFundingsListComponent {
  readonly fundings = input.required<EmployeeFundingDetails[]>();

  private readonly translateService = inject(TranslateService);

  protected readonly currLang = toSignal(
    this.translateService.onLangChange.pipe(
      map((change) => change?.lang),
      startWith(this.translateService.currentLang),
      distinctUntilChanged()
    )
  );
}
